import { breadcrumbsContent } from "../../breadcrumbs/BreadcrumbsContent";
import Button from "../../buttons/Button";
import useTranslation from "../../CustomHooks/useTranslation";
import ErrorMessage from "../../ErrorMessages/ErrorMessage";
import access from "../../utils/access";
import MapPrivilege from "./MapPrivilege";

interface AccessPrivilegeProps {
  handelCheckBox: (id: string) => void;
  checkedArray: string[];
  handelAllAccessPrivilege: () => void;
  isSupperAdmin: boolean;
  error: string;
  editLoading?: boolean;
}
const AccessPrivilege = ({
  handelCheckBox,
  checkedArray,
  handelAllAccessPrivilege,
  isSupperAdmin,
  editLoading,
  error,
}: AccessPrivilegeProps) => {
  const { translate, notEnglish } = useTranslation(breadcrumbsContent)
  return (
    <>
      <div dir={notEnglish ? 'rtl' : 'ltr'}>
        <h1 className={`text-heading3 text-primary_text underline pt-8 pb-4`}>
        {translate('Access Module')}
        </h1>
        {error && <ErrorMessage errorMessage={error} className={"mb-4"} />}
        <Button
          buttonName={translate("Mark as Super Admin")}
          className={`px-2 ${isSupperAdmin ? "" : "bg-white border"}`}
          textSize="text-large"
          // bgColor={isSupperAdmin ? "bg-primary_color" : ""}
          buttonDisabled={editLoading}
          textColor={!isSupperAdmin ? "text-primary_text" : ""}
          buttonOnclick={handelAllAccessPrivilege}
          testId="mark_as_super_admin"
          buttonHight="h-[45px]"
        />
        {Object.keys(access).map((accessItem, accessIndex = 0) => (
          <MapPrivilege
            editLoading={editLoading}
            accessItem={accessItem}
            key={accessItem}
            handelCheckBox={handelCheckBox}
            checkedArray={checkedArray}
            lastIndex={Object.keys(access).length - 1 === accessIndex}
          />
        ))}
      </div>
    </>
  );
};

export default AccessPrivilege;
